interface AdminDataErrorProps {
  message: string;
  onRetry?: () => void;
}

/**
 * Honest error banner for admin sections.
 *
 * With the silent mock fallback removed, a failing API is surfaced here — the
 * admin sees the real error plus a retry button instead of demo data pretending
 * to be live.
 */
export default function AdminDataError({ message, onRetry }: AdminDataErrorProps) {
  return (
    <div className="mb-4 flex items-start justify-between gap-3 rounded-lg bg-rose-50 px-4 py-3 text-xs text-rose-700">
      <span className="flex items-start gap-2.5">
        <i className="ri-error-warning-line mt-0.5 shrink-0 text-sm" />
        {message}
      </span>
      {onRetry ? (
        <button
          type="button"
          onClick={onRetry}
          className="shrink-0 cursor-pointer whitespace-nowrap rounded-md border border-rose-300 px-3 py-1 text-xs font-semibold text-rose-700 transition-colors hover:bg-rose-100"
        >
          Retry
        </button>
      ) : null}
    </div>
  );
}